import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {CaptionState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class CaptionQuery extends QueryEntity<CaptionState> {

  constructor(protected store: Store) {
    super(store);
  }

}
